export default "__VITE_ASSET__BPtir32J__"